import React from "react"



export const Ha = () => {
    return <iframe title="Home Assistant" src="https://mowebha.duckdns.org" />
}